import { render, staticRenderFns } from "./PollViewer.vue?vue&type=template&id=1b8fcb3e&scoped=true"
import script from "./PollViewer.vue?vue&type=script&lang=js"
export * from "./PollViewer.vue?vue&type=script&lang=js"
import style0 from "./PollViewer.vue?vue&type=style&index=0&id=1b8fcb3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8fcb3e",
  null
  
)

export default component.exports